import React from 'react';

import Box from '@mui/material/Box';

import Logo from '@legacy/components/logo';

export function PaybyrdLogo({ open = true, ...props }) {
  return (
    <Box {...props} sx={{ paddingTop: '12px' }}>
      <Logo id={props.id} viewBox={open ? '0 0 147 30' : '0 0 30 30'} />
    </Box>
  );
}

export default PaybyrdLogo;
